import { render } from "./addRect.vue?vue&type=template&id=7491ef96&scoped=true"
import script from "./addRect.vue?vue&type=script&lang=js"
export * from "./addRect.vue?vue&type=script&lang=js"

import "./addRect.vue?vue&type=style&index=0&id=7491ef96&scoped=true&lang=css"

import exportComponent from "C:\\vue2023\\cmsmap2023\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7491ef96"]])

export default __exports__